var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authors",attrs:{"id":"select-author"}},[_c('Select2',{ref:"select2",attrs:{"settings":_vm.selectConfig},on:{"select":function($event){return _vm.select($event)}},model:{value:(_vm.selectedItems),callback:function ($$v) {_vm.selectedItems=$$v},expression:"selectedItems"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }